export const InboxIcon = ({ className }: { className?: string }) => (
    <svg name="Inbox" className={className} width="16" height="16" viewBox="0 0 24 24">
        <path
            d="M19 3H4.99C3.88 3 3.01 3.89 3.01 5L3 19C3 20.1 3.88 21 4.99 21H19C20.1 21 21 20.1 21 19V5C21 3.89 20.1 3 19 3ZM19 15H15C15 16.66 13.65 18 12 18C10.35 18 9 16.66 9 15H4.99V5H19V15Z"
            fill="currentColor"
        />
    </svg>
);
